import { ModuleLayout } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router'

import { ImportedInvoicesUploadProvider } from '@features/importedInvoices/context/ImportedInvoicesUploadContext'
import { ImportedInvoicesDropzone } from '@features/importedInvoices/elements/ImportedInvoicesDropzone'
import { ImportedInvoicesUploadButton } from '@features/importedInvoices/elements/ImportedInvoicesUploadButton'
import { useImportedInvoicesFeature } from '@features/importedInvoices/hooks/useImportedInvoicesFeature'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../utils/routing/reactRoute'
import { ImportedInvoicesList } from './elements/ImportedInvoicesList'
import { useHasImportedInvoices } from './hooks/useHasImportedInvoices'

const ImportedInvoicesView = (): ReactElement => {
  const { t } = useTranslation()
  const { hasImportedInvoices } = useHasImportedInvoices()

  // The loading / empty / list decision lives inside ImportedInvoicesList, which reads the single
  // imported-invoices list query. This keeps the title + dropzone mounted (no full-page spinner flash
  // on background refetches such as the post-upload cache invalidation).
  return (
    <ImportedInvoicesUploadProvider>
      <ModuleLayout
        title={t('imported_invoices.title')}
        sideActions={hasImportedInvoices && <ImportedInvoicesUploadButton />}
      >
        <ImportedInvoicesDropzone />
        <ImportedInvoicesList />
      </ModuleLayout>
    </ImportedInvoicesUploadProvider>
  )
}

export const ImportedInvoices = (): ReactElement => {
  const { organization } = useUserOrganization()
  const { isEnabled } = useImportedInvoicesFeature()

  if (!isEnabled) {
    return (
      <Navigate
        to={getOrganizationViewUrl(organization?.url, reactRoute.organization.dashboard.getMainRoute())}
        replace
      />
    )
  }

  return <ImportedInvoicesView />
}
